export default {"src":"/_next/static/media/times-group.ceb90b13.svg","height":66,"width":152,"blurWidth":0,"blurHeight":0};